import { RoadMapUpdate } from '@/domain/roadmap/types';
import { toLocaleDateTimeString } from '@/utils/datetime';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

interface CreateByFieldProps {
  editableRoadMap: RoadMapUpdate;
}

export function CreatedByField({ editableRoadMap }: Readonly<CreateByFieldProps>) {
  const createdByText = editableRoadMap.createdBy ? `${editableRoadMap.createdBy}` : 'Created';

  const valueText = `${createdByText} on ${
    editableRoadMap.createdTimestamp ? toLocaleDateTimeString(editableRoadMap.createdTimestamp) : ''
  }`;
  return (
    <Box sx={{ py: 0.75 }}>
      <TextField
        label="Created By"
        value={valueText}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
        fullWidth
        disabled
      />
    </Box>
  );
}
